import { apiFetch } from "../helper/api";

export type SalesData = Record<string, {
    bed: string,
    price: string,
    status: "" | "Available" | "Sold" | "Conditional Exchange" | "Reserved", // Any others?
    saleStatus: "Stock" | "Contract Exchange" | "Held by Agent" | "Held by Vendor" | "Contract Issued" | "Conditional Exchange" | "Reserved" | "Holding Deposit" | "Contract Offer Approved" | "Settled" | "Unconditional Exchange", // Any others?
    max:boolean,
}>;


export async function fetchSalesData(username:string, password:string){
    const responseA = await apiFetch("https://cms.orchardsveue.com.au/api/app-get-live-data-json-zeste.php", {
        user_name: username,
        password,
        page: 0,
    })
    const dataA:any = await responseA.json();

    const responseB = await apiFetch("https://cms.orchardsveue.com.au/api/app-get-live-data-json-zeste.php", {
        user_name: username,
        password,
        page: 1,
    })
    const dataB:any = await responseB.json();

    const data = {
        ...dataA,
        ...dataB,
    //    ...dataC,
    }

     //Log the raw merged API data
    console.log("Raw API Data:");
    console.log(JSON.stringify(data, null, 2));


    const result:SalesData = {};
    // Object.keys(data).forEach(function(key){
    //     const unitNumber = parseInt(key.split(" ").pop()!)
    //     result[unitNumber] = data[key];

    // })

    Object.keys(data).forEach(function (key) {
  const cleanedKey = key.trim(); // remove leading/trailing spaces
  const unitNumber = parseInt(cleanedKey.replace('G', '')); // remove the 'G' and convert to number
  result[unitNumber] = data[key];
});

    //    Object.keys(data).forEach(function (key) {
    // const newKey = key.replace(/G/g, '00').trim(); // Trim to remove leading space
    // const unitNumber = parseInt(newKey.split("00").pop()!); // Extract numeric part
    // result[unitNumber] = data[key]; // Use original key for lookup
    // });

    return result;
}